/** @jsxRuntime classic */

/** @jsx jsx */
import { memo, useEffect } from 'react';
import { jsx, css } from '@emotion/core';
import { setTheme } from './set-theme';
import { makeStylesEls } from './make-styles';
import { string, object, node } from 'prop-types';
import { font } from '../styles/font';
const {
  fontFamily,
  fontFamilyBold,
  fontFamilyMedium,
  fontFamilyLink,
  fontFamilyBoldLink,
  fontFamilyMediumLink
} = font;
const ThemeProviderRoot = css`
    @font-face {
        font-family: ${fontFamilyBold};
        src: url('${fontFamilyBoldLink}') format('opentype');
    }
    @font-face {
        font-family: ${fontFamilyMedium};
        src: url('${fontFamilyMediumLink}') format('opentype');
    }
    @font-face {
        font-family: ${fontFamily};
        src: url('${fontFamilyLink}') format('opentype');
    }
    @font-face {
        font-family: ${fontFamily};
        font-weight: 400;
        src: url('${fontFamilyLink}') format('opentype');
    }
    @font-face {
        font-family: ${fontFamily};
        font-weight: 500;
        src: url('${fontFamilyMediumLink}') format('opentype');
    }
    @font-face {
        font-family: ${fontFamily};
        font-weight: 700;
        src: url('${fontFamilyBoldLink}') format('opentype');
    }
`;
const ThemeProvider = /*#__PURE__*/memo(({
  theme,
  className,
  children
}) => {
  useEffect(() => {
    return () => {
      if (makeStylesEls.length) {
        makeStylesEls.forEach(el => el && el.remove && el.remove());
      }
    };
  }, []);
  useEffect(() => {
    setTheme(theme);
  }, [theme]);
  return jsx("div", {
    css: ThemeProviderRoot,
    className: ['DGN-UI-Theme', className].join(' ').trim()
  }, children);
});
ThemeProvider.defaultProps = {
  theme: {},
  className: ''
};
ThemeProvider.propTypes = {
  theme: object,
  className: string,
  children: node
};
export default ThemeProvider;